import * as React from 'react';

export default function SectionDivider() {
  return <div style={{ borderBottom: '1px solid #E1E1E1', width: '100%', height: '1px', margin: '25px 0 0 0' }} />;
}
